module.exports = __webpack_public_path__ + "assets/4180af38e5387ee3e4ad981482a2a0d7.png";